import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import { Close } from "UI/Icons";
import { FlexibleTextArea } from "UI/Inputs";

var MatrixGradeStep = /*#__PURE__*/function (_Component) {
  _inherits(MatrixGradeStep, _Component);

  var _super = _createSuper(MatrixGradeStep);

  function MatrixGradeStep(props) {
    var _this;

    _classCallCheck(this, MatrixGradeStep);

    _this = _super.call(this, props);
    _this.state = {
      text: props.blockStep.text
    };
    return _this;
  }

  _createClass(MatrixGradeStep, [{
    key: "onStepChange",
    value: function onStepChange(text) {
      var _this2 = this;

      this.setState({
        text: text
      }, function () {
        _this2.props.onStepUpdate({
          id: _this2.props.blockStep.id,
          keyId: _this2.props.blockStep.keyId,
          text: _this2.state.text
        });
      });
    }
  }, {
    key: "onStepDelete",
    value: function onStepDelete() {
      this.props.onStepDelete({
        id: this.props.blockStep.id
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (this.props.blockStep.gradeF == null) {
        return /*#__PURE__*/React.createElement("div", {
          className: "form-row",
          key: this.props.key,
          style: {
            flex: "1",
            padding: "0",
            marginRight: "1em",
            marginTop: "1em",
            position: "relative"
          }
        }, /*#__PURE__*/React.createElement(FlexibleTextArea, {
          value: this.state.text != null ? this.state.text : "",
          placeholder: this.props.translate("text"),
          onChange: function onChange(event) {
            return _this3.onStepChange(event.target.value);
          }
        }), /*#__PURE__*/React.createElement("div", {
          onClick: function onClick(event) {
            return _this3.onStepDelete();
          },
          className: "tooltip",
          "data-tooltip": this.props.translate("delete-step"),
          style: {
            position: "absolute",
            top: "17px",
            right: "15px",
            cursor: "pointer",
            height: "1em"
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: "15px"
          }
        }, /*#__PURE__*/React.createElement(Close, null))));
      } else {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            flex: "1",
            flexGrow: "0",
            padding: "0",
            position: "relative",
            marginTop: "1em",
            marginRight: "2em"
          },
          className: "form-row"
        }, /*#__PURE__*/React.createElement(FlexibleTextArea, {
          value: this.state.text != null ? this.state.text : "",
          style: {
            width: "130px",
            height: "50px",
            fontSize: "1em",
            overflow: "hidden"
          },
          disabled: true
        }));
      }
    }
  }]);

  return MatrixGradeStep;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {})(MatrixGradeStep);